var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    ref: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      border: "",
      data: _vm.currentTableData,
      size: "mini",
      stripe: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "函证号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "函证对象"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "函证类型",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "发函日期",
      width: "88"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "发函快递公司",
      width: "88"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "快递单号",
      width: "88"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "发函费用",
      width: "88"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "回函日期",
      width: "88"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "回函快递公司",
      width: "88"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "快递单号",
      width: "88"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "回函费用",
      width: "88"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "text",
            size: "mini"
          }
        }, [_vm._v("删除")])];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };